import { Dayjs } from 'dayjs';

import { format } from './format';

export const toDate = (value: ParsableDate | Dayjs | null): string => format(value, 'DD/MM/YYYY');
